// Footer.js
import React from 'react';

const Footer = () => {
    return (
        <footer className="pv4 ph3 ph5-m ph6-l mid-white">
            <div className="tc mt3">
                <a href="https://devbros.io" title="Devbros" className="f6 dib ph2 link light-blue dim" target="_blank" rel="noopener noreferrer">Made by Devbros</a>
            </div>
        </footer>
    );
}

export default Footer;
